import Footer from '../features/layout/footer/Footer';

export const FooterApp: React.FC = () => {
  return <Footer />;
};
